<template>
  <v-container
    class="fill-height justify-center"
    style="height: 90vh;"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="11" sm="8" md="6" lg="5" xl="5">
        <v-card class="elevation-6">
          <v-card-title class="pb-0">
            <v-btn color="secondary" text @click="$router.go(-1)">
              <v-icon>mdi-chevron-left</v-icon>
              {{ $vuetify.lang.t('$vuetify.LOG_IN') }}
            </v-btn>
          </v-card-title>
          <div class="pa-7 pa-sm-12">
            <img src="@/assets/logo-black.svg" style="width: 92px;" />
            <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">
              {{ $vuetify.lang.t('$vuetify.LOGIN.FORGOT_PASSWORD_TITLE') }}
            </h2>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              action="/dashboards/analytical"
            >
              <v-text-field
                v-model="email"
                :rules="emailRules"
                :label="$vuetify.lang.t('$vuetify.LOGIN.EMAIL')"
                class="mt-4"
                required
                outlined
              ></v-text-field>
              <!-- <v-text-field
                v-model="password"
                :rules="passwordRules"
                :label="$vuetify.lang.t('$vuetify.LOGIN.PASSWORD')"
                required
                outlined
                :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                :type="passwordVisible ? 'text' : 'password'"
                @click:append="() => (passwordVisible = !passwordVisible)"
              ></v-text-field> -->

              <span v-if="error" class="error--text">{{ error.message }}</span>

              <!-- <div class="d-block d-sm-flex align-center mb-4 mb-sm-0">
                <v-checkbox
                  v-model="rememberMe"
                  label="Remember me?"
                ></v-checkbox>
                <div class="ml-auto">
                  <a href="javascript:void(0)" class="secondary--text">
                    {{ $vuetify.lang.t('$vuetify.LOGIN.FORGOT_PASSWORD') }}
                  </a>
                </div>
              </div> -->
              <v-btn
                :disabled="!valid"
                color="secondary"
                block
                class="mr-4"
                submit
                @click="resetPassword()"
              >
                {{ $vuetify.lang.t('$vuetify.LOGIN.SUBMIT') }}
              </v-btn>
            </v-form>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ForgotPassword',

  data: () => ({
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    valid: false
  }),
  computed: {
    ...mapGetters('app', ['error', 'selectedLanguage']),
  },
  methods: {
    resetPassword() {
      this.$store
        .dispatch('authentication/resetPassword', {          
          Email: this.email,
          Language: this.selectedLanguage.code
        })
        .then(() => {
          this.$router.replace('/')
        })
    }
  }
}
</script>
